﻿import React from 'react';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import RadioButton from '../../../Forms/Components/RadioButton';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';

class Step6Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper;

        return (
            <StepForm heading="Har du fritidshus?">
                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="hasVacationHome__ja"
                    name="hasVacationHome"
                    displayname="Ja"
                    value="ja"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.hasVacationHome === 'ja'}
                />

                <RadioButton 
                    layout="inline"
                    theme="big"
                    id="hasVacationHome__nej"
                    name="hasVacationHome"
                    displayname="Nej"
                    value="nej"
                    validations={[required]}
                    data-validation-error-message="Välj en"
                    defaultChecked={this.props.formData.hasVacationHome === 'nej'}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step6Form, guideStep: 6 });